'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const UserStore = require('../../../global/stores/UserStore.es');
const { makeOfferLauncher } = require('dibs-buyer-layout/src/entries/index');
const ArrowRightIcon = require('dibs-vg/dist/react/arrow-right');
const PurchaseTracking = require('../../../global/mixins/purchaseTracking');
const classNames = require('classnames');
const css = require('../ItemActionButtons-style.scss');
const copy = require('../../../../../json/copy/itemActionButtons.json');
const { trackMakeOfferModalOpened } = require('./trackingHelpers.es');

class MakeOfferButton extends React.Component {
    constructor(props) {
        super(props);
        this.onMakeOffer = this.onMakeOffer.bind(this);
        if (props.tracking) {
            this.purchaseTracking = new PurchaseTracking({
                item: props.item,
                pageContext: props.tracking.pageContext,
            });
            this.purchaseTracking.url = props.tracking.url || document.URL;
        }
    }

    onMakeOffer() {
        const { context, currency, tracking, enableRequestNetPrice } = this.props;
        const { pageContext } = tracking || {};
        const userCurrency = context ? context.getStore(UserStore).getCurrency() : currency;

        makeOfferLauncher(
            Object.assign(
                {
                    currency: userCurrency,
                    purchaseTracking: this.purchaseTracking,
                    linkLocation: pageContext,
                },
                this.props
            )
        );

        if (this.purchaseTracking) {
            trackMakeOfferModalOpened({
                purchaseTracking: this.purchaseTracking,
                url: this.purchaseTracking.url,
                isTrade: enableRequestNetPrice,
            });
        }
    }

    render() {
        const { buttonClass } = this.props;
        const showArrow = !buttonClass || buttonClass === 'button-large';
        const cls = classNames('button', 'button-secondary', buttonClass, {
            'button-large': !buttonClass,
        });
        let arrow;
        if (showArrow) {
            arrow = <ArrowRightIcon className={css.itemActionRightArrow} />;
        }
        return (
            <button className={cls} data-tn="item-actions-make-offer" onClick={this.onMakeOffer}>
                {copy.makeOffer}
                {arrow}
            </button>
        );
    }
}

MakeOfferButton.propTypes = {
    buttonClass: PropTypes.string,
    tracking: PropTypes.object,
    item: PropTypes.object.isRequired,
    transaction: PropTypes.object,
    enableRequestNetPrice: PropTypes.bool,
    context: PropTypes.object,
    currency: PropTypes.string,
};

module.exports = MakeOfferButton;



// WEBPACK FOOTER //
// ./assets/js/components/ItemActionButtons/MakeOfferButton/MakeOfferButton.jsx